import { RefillTooSoonReason } from "common/types/carts";

export const refillTooSoonOptions: Record<RefillTooSoonReason, string> = {
  [RefillTooSoonReason.Travel]: "I am traveling and need supply in advance",
  [RefillTooSoonReason.LostOrDamaged]: "Last fill of this medication was lost or damaged",
  [RefillTooSoonReason.DifficultyDosing]:
    "Administration of medication is difficult and additional supply is needed",
};

/** Shipping states whose automatic renewal laws require the client's consent to an Autoship. */
export const AUTOSHIP_CONSENT_STATES = ["CA", "NY", "TX", "OR"];
